import get from 'lodash/get'

export const getVegetation = (state) => get(state, ['vegetation'])
export const getClientConfiguration = (state) => get(getVegetation(state), ['configuration', 'config'])
export const isLoadingClientConfiguration = (state) => get(getVegetation(state), ['configuration', 'loading'])



// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/clientConfiguration.js